import { Chip } from "@mui/material";
import type { ActivityCellProjection } from "../activityColumns";

export function ActivityCellContent({ cell }: { cell: ActivityCellProjection }) {
  if (cell.kind === "activity-status") {
    return (
      <Chip
        size="small"
        variant="outlined"
        color={cell.status === "Hit" ? "success" : "error"}
        label={cell.status}
      />
    );
  }

  return cell.text;
}
